import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { DocumentService } from '@kailona/core';
import DocumentsDataModule from './components/DocumentsDataModule';
var _default = {
  id: 'plugin-documents',
  path: '/documents',
  name: t('ehr', 'Documents'),
  MenuModule: {
    name: t('ehr', 'Documents'),
    icon: 'DescriptionOutlined',
    priority: 50
  },
  WidgetModule: {
    name: t('ehr', 'Documents'),
    icon: 'DescriptionOutlined',
    priority: 50
  },
  DataModule: {
    Component: DocumentsDataModule,
    importData: function () {
      var _importData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
        var documentService;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                documentService = new DocumentService();
                _context.next = 3;
                return documentService.import(file);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function importData(_x) {
        return _importData.apply(this, arguments);
      }

      return importData;
    }()
  }
};
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/plugins/documents/src/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();